module.exports = __webpack_public_path__ + "static/media/loading-icon.5f80bbf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chatbot/assets/loading-icon.svg
// module id = 466
// module chunks = 0